"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTokenDefaultStrategy = void 0;
var refresh_token_1 = require("../../service/refresh-token");
var execute = function () {
    return refresh_token_1.refreshTokenService.refreshToken();
};
exports.refreshTokenDefaultStrategy = {
    execute: execute,
};
